// Mirrors SESSION_NAME_MAX_LENGTH in BB_SessionService/src/utils/validators.js
export const SESSION_NAME_MAX_LENGTH = 100;

// Sessions created before sessionName existed fall back to their sessionId,
// matching the backend's create-time default.
export const getSessionDisplayName = (session) => session?.sessionName || session?.sessionId || '';

export const validateSessionName = (name) => {
    const trimmed = (name || '').trim();
    if (!trimmed) return 'Required';
    if (trimmed.length > SESSION_NAME_MAX_LENGTH) return `Must be at most ${SESSION_NAME_MAX_LENGTH} characters`;
    return null;
};
